import { tv, type VariantProps } from "tailwind-variants"
export type InteractiveTextVariantProps = VariantProps<
  typeof interactiveVariants
>

export const interactiveVariants = tv({
  base: "cursor-pointer",
  variants: {
    text: {
      primary: "text-text-primary hover:text-text-secondary",
      secondary: "text-text-secondary hover:text-text-primary",
      tertiary: "text-text-tertiary hover:text-text-primary",
    },
    fill: {
      primary: "fill-text-primary hover:fill-text-secondary",
      secondary: "fill-text-secondary hover:fill-text-primary",
      tertiary: "fill-text-tertiary hover:fill-text-primary",
    },
  },
})
